export default {"src":"/_next/static/media/star.b4a7deb3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};